import { render, staticRenderFns } from "./BeforeLogin.vue?vue&type=template&id=7968a3b8&scoped=true&"
var script = {}
import style0 from "./BeforeLogin.vue?vue&type=style&index=0&id=7968a3b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968a3b8",
  null
  
)

export default component.exports